<template>
    <div class="quiz-progress">
        <ul class="quiz-progress__list">
            <li v-for="(questions, index) in quiz_data.questions"
                :key="index"
                class="quiz-progress__item"
                v-bind:class="{'quiz-progress__item--current': (index === quiz_state.current_question) }">

                {{ index + 1 }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "QuizProgress",
    props: {
        quiz_data: Object,
        quiz_state: Object
    }
}
</script>

<style scoped lang="stylus">
.quiz-progress {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 2.8em;
    left: 0;
    right: 0
    margin: 0 auto;
    z-index: 100;
    padding: 0;
    font-size: 1em;
    user-select none;

    &__list {
        display: flex;
        padding: 4px;
        border-radius: 5em;
        margin: 0;
        gap: 0.3em;
        font-family: font-HanleyPro-Sans;
        background: rgba(255, 255, 255, 0.5);
    }

    &__item {
        list-style: none;
        padding: 0;
        margin: 0;
        height: 2em;
        width: 2em;
        line-height: 2em;
        border-radius: 50%;
        color: brand-blue;
        font-weight: bold;
        transition: all 0.3s ease-in-out;

        &--current {
            background-color: brand-yellow;
            color: brand-grey;
            text-shadow: none;
            box-shadow: inset 0 -2px 2px rgba(0, 0, 0, 0.2), inset 0 2px 2px rgba(255, 255, 255, 0.5)
        }
    }

    @media (min-width: 1000px) {
        top: 120px;
        bottom: 0;
        left: 2em;
        right: auto;
        position: fixed;

        &__list {
            flex-direction: column;
            background: rgba(255, 255, 255, 0.5);
            backdrop-filter: blur(5px) saturate(250%);
            box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
        }

        &__item {
            margin: 0;
            font-size: 1.1em;
        }
    }

    @media (min-width: 1400px) {



        &__item {
            font-size: 1.3em;
        }
    }
}
</style>